import React, { useState, useEffect, Component } from "react";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import { Dropdown, Loader } from "semantic-ui-react";
import { Chart } from "react-google-charts";
import moment from "moment";
import axios from "axios";
import config from "../../config/config";
import api from "../../config/api";
import momentTz from "moment-timezone";
import { db, auth } from "../../config/firebase";
import { Pie } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";

// Dropdowns
import PlaceList from "../../components/PlaceList";
import MonthList from "../../components/MonthList";
import YearList from "../../components/YearList";
import ChartList from "../../components/ChartList";

const BuildForm = (props) => {
  let form_id = "",
    form_category = "",
    form_main_place = "",
    form_sub_place = "",
    form_datetime = "",
    form_type = "";

  form_id = props.form_id;
  form_category = props.form_category;
  form_main_place = props.form_main_place;
  form_sub_place = props.form_sub_place;
  form_datetime = props.form_datetime;
  form_type = props.form_type;

  return (
    <div className="form-indi">
      <div className="form-indi-left">
        <div className="form-indi-type">{form_type}</div>
        <div>
          <p className="form-indi-mainplace">{form_main_place}</p>
          <p className="form-indi-subplace">{form_sub_place}</p>
          <p className="form-indi-datetime">{form_datetime}</p>
        </div>
      </div>
      <div className="form-indi-right">
        <p className="form-indi-id">{form_id}</p>
        <br></br>
        <br></br>
        <div className="form-indi-cat-div">
          <p>{form_category}</p>
        </div>
      </div>
    </div>
  );
};
const initialState = {};

function IncidentList(props) {
  const [queryDate, setQueryDate] = useState(momentTz().format("MMMYYYY"));
  const [queryYear, setQueryYear] = useState(momentTz().format("YYYY"));
  const [queryMonth, setQueryMonth] = useState(momentTz().format("MMMM"));
  const [queryPlace, setQueryPlace] = useState("Singapore Zoo");
  const [loader, setLoader] = useState(true);

  const [showCatPie, setShowCatPie] = useState(false);
  const [categoryCount, setCategoryCount] = useState({
    c1: 0,
    c2: 0,
    c3: 0,
    c4: 0,
  });
  const [incidentStatusCount, setIincidentStatusCount] = useState({
    all: 0,
    archived: 0,
    closed: 0,
    draft: 0,
    open: 0,
    pending_approval: 0,
    pending_save: 0,
  });
  const [typeIncidentCount, setTypeIncidentCount] = useState({
    others: 0,
    place_management: 0,
    safety: 0,
    security: 0,
  });
  const [totalTypeofIncidentCount, setTotalTypeofIncidentCount] = useState({
    "Caught in between object": 0,
    "Ergonomic": 0,
    "Health condition": 0,
    "Hurt by animal/insect in our care": 0,
    "Hurt by animal/insect NOT in our care": 0,
    "Slip and fall": 0,
    "Trip and fall": 0,
    "Others": 0,
  })
  const [guestTypeofIncidentCount, setGuestTypeofIncidentCount] = useState({
    "Caught in between object": 0,
    "Ergonomic": 0,
    "Health condition": 0,
    "Hurt by animal/insect in our care": 0,
    "Hurt by animal/insect NOT in our care": 0,
    "Slip and fall": 0,
    "Trip and fall": 0,
    "Others": 0,
  })
  const [staffTypeofIncidentCount, setStaffTypeofIncidentCount] = useState({
    "Caught in between object": 0,
    "Ergonomic": 0,
    "Health condition": 0,
    "Hurt by animal/insect in our care": 0,
    "Hurt by animal/insect NOT in our care": 0,
    "Slip and fall": 0,
    "Trip and fall": 0,
    "Others": 0,
  })
  const [guestWhatIsTheInjuryCount, setGuestWhatIsTheInjuryCount] = useState({
    "Cut & laceration": 0, 
    "Bite / Sting / Scratch": 0, 
    "Sprain & strains": 0, 
    "Allergy / rash": 0, 
    "Bruise & contusion": 0, 
    "Burn": 0,
    "Others": 0,
  })
  const [staffWhatIsTheInjuryCount, setStaffWhatIsTheInjuryCount] = useState({
    "Cut & laceration": 0, 
    "Bite / Sting / Scratch": 0, 
    "Sprain & strains": 0, 
    "Allergy / rash": 0, 
    "Bruise & contusion": 0, 
    "Burn": 0,
    "Others": 0,
  })
  const [guestCPCBCCount, setGuestCPCDBCount] = useState({
    "C": 0,
    "PC": 0,
    "BC": 0,
  })
  const [staffCPCBCCount, setStaffCPCDBCount] = useState({
    "C": 0,
    "PC": 0,
    "BC": 0,
  })
  const [showTypePie, setShowTypePie] = useState(false);
  const [showStatusPie, setShowStatusPie] = useState(false);

  // api
  const { url } = config;
  const { SAVE_USER, GET_DASHBOARD_COUNT } = config.api_endpoint;
  const { GET_INCIDENTS } = config.api_endpoint;
  // pie charts data
  const [catPie, setCatPie] = useState({
    c1: 0,
    c2: 0,
    c3: 0,
    c4: 0,
  });

  const [typePie, setTypePie] = useState([
    ["Type", "No of forms"],
    ["Safety", 0],
    ["Security", 0],
    ["Place Management", 0],
    ["Others", 0],
  ]);

  const [statusPie, setStatusPie] = useState([
    ["Status", "No of forms"],
    ["Open", 0],
    ["Pending Approval", 0],
    ["Draft", 0],
    ["Closed", 0],
    ["Archived", 0],
  ]);

  const [parkList, setParkList] = useState([]);

  useEffect(() => {
    db.collection("static_data")
      .doc("parks")
      .get()
      .then((querySnapshot) => {
        let parkData = [];

        parkData.push({
          key: "All",
          text: "All",
          value: "All",
        });
        querySnapshot.data().parks_arr.forEach((doc, index) => {
          parkData.push({
            key: index,
            text: doc.park,
            value: doc.park,
          });
        });

        setParkList(parkData);
      })
      .catch((err) => {
        console.log("Error getting dashboard parks:", err);
      });
  }, []);

  const constmonths = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  useEffect(() => {
    setLoader(true);
    const localItems = JSON.parse(localStorage.getItem("pending"));
    let filterLocalItems = [];

    let itemsLength = 0;
    if (localItems == null || localItems == undefined) {
      itemsLength = 0;
    } else {
      localItems.map((l, index) => {
        if (
          new Date(l.latest_updated_at).getFullYear() == queryYear &&
          constmonths[new Date(l.latest_updated_at).getMonth()] == queryMonth
        ) {
          filterLocalItems.push(l);
        }
      });

      itemsLength = filterLocalItems.length;
    }

    api
      .get(GET_DASHBOARD_COUNT, {
        platform: "web",
        year: queryYear,
        month: queryMonth,
        park: queryPlace == "All" ? "" : queryPlace,
        user_id: props.AuthDetail.id,
      })
      .then((res) => {
        setCategoryCount(res.category);
        setIincidentStatusCount({
          ...res.incident_status,
          pending_save: itemsLength,
        });
        setTypeIncidentCount(res.incident_type_numbers);

        setTotalTypeofIncidentCount(res.total_incident_type);
        setGuestTypeofIncidentCount(res.guest_incident_type);
        setStaffTypeofIncidentCount(res.staff_incident_type);
        setGuestWhatIsTheInjuryCount(res.guest_what_is_the_injury);
        setStaffWhatIsTheInjuryCount(res.staff_what_is_the_injury);
        setGuestCPCDBCount(res.guest_c_pc_bc);
        setStaffCPCDBCount(res.staff_c_pc_bc);

        // if (
        //   res.category.c1 == 0 &&
        //   res.category.c2 == 0 &&
        //   res.category.c3 == 0 &&
        //   res.category.c4 == 0
        // ) {
        //   setShowCatPie(false);
        //   setLoader(false);
        // } else {
        setShowCatPie(true);
        setCatPie({
          cat1: res.category.c1,
          cat2: res.category.c2,
          cat3: res.category.c3,
          cat4: res.category.c4,
        });
        setLoader(false);
        // }

        // if (
        //   res.incident_type_numbers.Safety == 0 &&
        //   (res.incident_type_numbers.Security == 0) &
        //     (res.incident_type_numbers["Place Management"] == 0) &&
        //   res.incident_type_numbers.Others == 0
        // ) {
        //   setShowTypePie(false);
        //   setLoader(false);
        // } else {
        setShowTypePie(true);
        setTypePie(
          [
            ["Type", "No of forms"],
            ["Safety", res.incident_type_numbers.Safety],
            ["Place Management", res.incident_type_numbers["Place Management"]],
            ["Security", res.incident_type_numbers.Security],

            ["Others", res.incident_type_numbers.Others],
          ],
          [queryDate]
        );
        setLoader(false);
        // }

        // if (
        //   res.incident_status.Closed == 0 &&
        //   res.incident_status.Open == 0 &&
        //   res.incident_status["Pending Approval"] == 0 &&
        //   res.incident_status.Draft == 0 &&
        //   res.incident_status.Archived == 0 &&
        //   itemsLength == 0
        // ) {
        //   setShowStatusPie(false);
        // } else {
        //   setShowStatusPie(true);
        setStatusPie(
          [
            ["Status", "No of forms"],
            ["Open", res.incident_status.Open],
            ["Pending Approval", res.incident_status["Pending Approval"]],
            ["Draft", res.incident_status.Draft],
            ["Pending Save", itemsLength],
            ["Closed", res.incident_status.Closed],
            ["Archived", res.incident_status.Archived],
          ],
          [queryDate]
        );
        setLoader(false);
        // }
      })
      .catch((err) => {
        console.log("err", err);
      });
  }, [queryDate, queryYear, queryMonth, queryPlace]);

  useEffect(() => {
    auth.onAuthStateChanged(async (user) => {
      if (user) {
        const getToken = await auth.currentUser.getIdToken();

        axios
          .post(
            url + SAVE_USER,
            {
              id: user.uid,
              is_active: 1,
              is_new: 0,
              platform: "web",
            },
            {
              headers: { Authorization: `Bearer ${getToken}` },
            }
          )
          .then((result) => {})
          .catch((err) => console.log("err", err));
      } else {
        auth.signOut();
      }
    });
  });

  const dots = (color) => {
    return (
      <div
        style={{
          width: 10,
          height: 10,
          background: color,
          borderRadius: 50,
          marginRight: 8,
        }}
      ></div>
    );
  };

  const pieCatdata = {
    labels: ["Cat 1", "Cat 2", "Cat 3", "Cat 4"],
    datasets: [
      {
        label: "Categories",
        data: [catPie.cat1, catPie.cat2, catPie.cat3, catPie.cat4],
        backgroundColor: ["#0DBE57", "#ECBB00", "#FF8962", "#E85757"],

        borderWidth: 1,
      },
    ],
  };

  const pieTypeIncidentdata = {
    labels: ["Safety", "Security", "Place Management", "Others"],
    datasets: [
      {
        label: "Categories",
        data: [
          typeIncidentCount.Safety,
          typeIncidentCount["Security"],
          typeIncidentCount["Place Management"],
          typeIncidentCount["Others"],
        ],
        backgroundColor: ["#008237", "#2D8CE3", "#E72D35", "#8F8F8F"],

        borderWidth: 1,
      },
    ],
  };
  const pieTypeStatusdata = {
    labels: [
      "Open",
      "Pending Approval",
      "Draft",
      "Pending Save",
      "Closed",
      "Archived",
    ],
    datasets: [
      {
        label: "Categories",
        data: [
          incidentStatusCount["Open"],
          incidentStatusCount["Pending Approval"],
          incidentStatusCount["Draft"],
          incidentStatusCount["pending_save"],
          incidentStatusCount["Closed"],
          incidentStatusCount["Archived"],
        ],
        backgroundColor: [
          "#ECBB00",
          "#E72D35",
          "#ff8c00",
          "#2D8CE3",
          "#089B46",
          "#8F8F8F",
        ],

        borderWidth: 1,
      },
    ],
  };

  const pieGuestCPCBCdata = {
    labels: [
      "C",
      "PC",
      "BC",
    ],
    datasets: [
      {
        label: "Guest C, PC, BC",
        data: [
          guestCPCBCCount["C"],
          guestCPCBCCount["PC"],
          guestCPCBCCount["BC"],
        ],
        backgroundColor: [
          "#ECBB00",
          "#E72D35",
          "#ff8c00",
        ],

        borderWidth: 1,
      },
    ],
  };

  const pieStaffCPCBCdata = {
    labels: [
      "C",
      "PC",
      "BC",
    ],
    datasets: [
      {
        label: "Guest C, PC, BC",
        data: [
          staffCPCBCCount["C"],
          staffCPCBCCount["PC"],
          staffCPCBCCount["BC"],
        ],
        backgroundColor: [
          "#ECBB00",
          "#E72D35",
          "#ff8c00",
        ],

        borderWidth: 1,
      },
    ],
  };

  const pieTotalIncidentdata = {
    labels: [
      "Caught in between object",
      "Ergonomic",
      "Health condition",
      "Hurt by animal/insect in our care",
      "Hurt by animal/insect NOT in our care",
      "Slip and fall",
      "Trip and fall",
      "Others",
    ],
    datasets: [
      {
        label: "Total Incident",
        data: [
          totalTypeofIncidentCount["Caught in between object"],
          totalTypeofIncidentCount["Ergonomic"],
          totalTypeofIncidentCount["Health condition"],
          totalTypeofIncidentCount["Hurt by animal/insect in our care"],
          totalTypeofIncidentCount["Hurt by animal/insect NOT in our care"],
          totalTypeofIncidentCount["Slip and fall"],
          totalTypeofIncidentCount["Trip and fall"],
          totalTypeofIncidentCount["Others"],
        ],

        backgroundColor: [
          "#ECBB00",
          "#E72D35",
          "#ff8c00",
          "#2D8CE3",
          "#089B46",
          "#8F8F8F",
          "#775656ff",
          "#ce6c6cff",
        ],

        borderWidth: 1,
      },
    ],
  };

  const pieGuestIncidentdata = {
    labels: [
      "Caught in between object",
      "Ergonomic",
      "Health condition",
      "Hurt by animal/insect in our care",
      "Hurt by animal/insect NOT in our care",
      "Slip and fall",
      "Trip and fall",
      "Others",
    ],
    datasets: [
      {
        label: "Guest Incident",
        data: [
          guestTypeofIncidentCount["Caught in between object"],
          guestTypeofIncidentCount["Ergonomic"],
          guestTypeofIncidentCount["Health condition"],
          guestTypeofIncidentCount["Hurt by animal/insect in our care"],
          guestTypeofIncidentCount["Hurt by animal/insect NOT in our care"],
          guestTypeofIncidentCount["Slip and fall"],
          guestTypeofIncidentCount["Trip and fall"],
          guestTypeofIncidentCount["Others"],
        ],

        backgroundColor: [
          "#ECBB00",
          "#E72D35",
          "#ff8c00",
          "#2D8CE3",
          "#089B46",
          "#8F8F8F",
          "#775656ff",
          "#ce6c6cff",
        ],

        borderWidth: 1,
      },
    ],
  };

  const pieStaffIncidentdata = {
    labels: [
      "Caught in between object",
      "Ergonomic",
      "Health condition",
      "Hurt by animal/insect in our care",
      "Hurt by animal/insect NOT in our care",
      "Slip and fall",
      "Trip and fall",
      "Others",
    ],
    datasets: [
      {
        label: "Staff Incident",
        data: [
          staffTypeofIncidentCount["Caught in between object"],
          staffTypeofIncidentCount["Ergonomic"],
          staffTypeofIncidentCount["Health condition"],
          staffTypeofIncidentCount["Hurt by animal/insect in our care"],
          staffTypeofIncidentCount["Hurt by animal/insect NOT in our care"],
          staffTypeofIncidentCount["Slip and fall"],
          staffTypeofIncidentCount["Trip and fall"],
          staffTypeofIncidentCount["Others"],
        ],

        backgroundColor: [
          "#ECBB00",
          "#E72D35",
          "#ff8c00",
          "#2D8CE3",
          "#089B46",
          "#8F8F8F",
          "#775656ff",
          "#ce6c6cff",
        ],

        borderWidth: 1,
      },
    ],
  };

  const pieGuestTypeofInjurydata = {
    labels: [
      "Cut & laceration", 
      "Bite / Sting / Scratch", 
      "Sprain & strains", 
      "Allergy / rash", 
      "Bruise & contusion", 
      "Burn",
      "Others",
    ],
    datasets: [
      {
        label: "Guest Type of Injury",
        data: [
          guestWhatIsTheInjuryCount["Cut & laceration"],
          guestWhatIsTheInjuryCount["Bite / Sting / Scratch"],
          guestWhatIsTheInjuryCount["Sprain & strains"],
          guestWhatIsTheInjuryCount["Allergy / rash"],
          guestWhatIsTheInjuryCount["Bruise & contusion"],
          guestWhatIsTheInjuryCount["Burn"],
          guestWhatIsTheInjuryCount["Others"],
        ],

        backgroundColor: [
          "#ECBB00",
          "#E72D35",
          "#ff8c00",
          "#2D8CE3",
          "#089B46",
          "#8F8F8F",
          "#cf33b5ff",
        ],

        borderWidth: 1,
      },
    ],
  };

  const pieStaffTypeofInjurydata = {
    labels: [
      "Cut & laceration", 
      "Bite / Sting / Scratch", 
      "Sprain & strains", 
      "Allergy / rash", 
      "Bruise & contusion", 
      "Burn",
      "Others"
    ],
    datasets: [
      {
        label: "Staff Type of Injury",
        data: [
          staffWhatIsTheInjuryCount["Cut & laceration"],
          staffWhatIsTheInjuryCount["Bite / Sting / Scratch"],
          staffWhatIsTheInjuryCount["Sprain & strains"],
          staffWhatIsTheInjuryCount["Allergy / rash"],
          staffWhatIsTheInjuryCount["Bruise & contusion"],
          staffWhatIsTheInjuryCount["Burn"],
          staffWhatIsTheInjuryCount["Others"],
        ],

        backgroundColor: [
          "#ECBB00",
          "#E72D35",
          "#ff8c00",
          "#2D8CE3",
          "#089B46",
          "#8F8F8F",
          "#cf33b5ff",
        ],

        borderWidth: 1,
      },
    ],
  };

  // const options = {
  //   responsive: true,

  //   plugins: {
  //     datalabels: {
  //       display: true,
  //       color: "white",
  //       formatter: (value, ctx) => {
  //         if (value == 0) {
  //           return null;
  //         } else {
  //           let sum = 0;
  //           let dataArr = ctx.chart.data.datasets[0].data;
  //           dataArr.map((data) => {
  //             sum += data;
  //           });
  //           let percentage = ((value * 100) / sum).toFixed(2) + "%";
  //           if (((value * 100) / sum).toFixed(2) < 7) {
  //             return null;
  //           } else {
  //             return percentage;
  //           }
  //         }
  //       },
  //     },
  //     legend: {
  //       display: false,
  //     },
  //   },
  // };

  // const options = {
  //   responsive: true,
  //   plugins: {
  //     legend: {
  //       display: false, // remove outer legend
  //     },
  //     datalabels: {
  //       clamp: true, // stops text from overflowing
  //       clip: false, // ensures text doesn't go outside the chart
  //       textAlign: "center",
  //       color: "#000000ff",
  //       display: true,
  //       font: { weight: "bold", size: 20 },
  //       formatter: (value, ctx) => {
  //         if (value === 0) return null;
  //         const total = ctx.chart.data.datasets[0].data.reduce((a, b) => a + b, 0);
  //         const percent = ((value / total) * 100).toFixed(1);
  //         // show percentage + label (like screenshot)
  //         return `${ctx.chart.data.labels[ctx.dataIndex]}\n${total} ${percent}%`;
  //       },
  //       backgroundColor: "rgba(255, 255, 255, 0.6)", // dark translucent background
  //       borderColor: "#fff", // white border
  //       //borderWidth: 1,
  //       borderRadius: 100,
  //     },
  //     tooltip: {
  //       enabled: true,
  //       titleFont: {
  //           size: 20, // increase title font size
  //           weight: 'bold'
  //       },
  //       bodyFont: {
  //           size: 20 // increase body font size
  //       },
  //       padding: 12, // increase padding inside tooltip
  //       boxPadding: 8, // padding around color boxes
  //       // optional: increase spacing between title/body
  //       titleSpacing: 6,
  //       bodySpacing: 4
  //     }
  //   },
  //   layout: {
  //     padding: 10,
  //   },
  // };

  const options = {
    responsive: true,
    maintainAspectRatio: true,
    aspectRatio: 1,
    plugins: {
      legend: { display: false },
      datalabels: {
        color: "#000",
        textAlign: "center",
        backgroundColor: "rgba(255,255,255,0.9)",
        borderColor: "rgba(0,0,0,0.15)",
        borderWidth: 1,
        borderRadius: 6,
        padding: 5,
        clamp: false,
        clip: false,

        // dynamic positioning: big slices = center, small slices = outside
        align: (ctx) => {
          const data = ctx.chart.data.datasets[0].data;
          const total = data.reduce((a, b) => a + b, 0);
          const value = data[ctx.dataIndex];
          const percent = (value / total) * 100;
          return percent < 6 ? "end" : "center";
        },
        anchor: (ctx) => {
          const data = ctx.chart.data.datasets[0].data;
          const total = data.reduce((a, b) => a + b, 0);
          const value = data[ctx.dataIndex];
          const percent = (value / total) * 100;
          return percent < 6 ? "end" : "center";
        },

        font: (ctx) => {
          const count = ctx.chart.data.datasets[0].data.length;
          if (count > 10) return { weight: "600", size: 8 };
          if (count > 7) return { weight: "600", size: 9 };
          return { weight: "600", size: 10 };
        },

        display: (ctx) => {
          const value = ctx.dataset.data[ctx.dataIndex];
          return value !== 0; // hide only zero values
        },

        formatter: (value, ctx) => {
          const data = ctx.chart.data.datasets[0].data;
          const total = data.reduce((a, b) => a + b, 0);
          const percent = ((value / total) * 100).toFixed(1);
          const label = ctx.chart.data.labels[ctx.dataIndex];
          // show all, even small ones, with one decimal if small
          // return percent >= 1 ? `${label}\n${total} ${percent}%` : `${label}`;
          return `${percent}%`
        },
      },
    },
    layout: { padding: 0 },
  };



  return (
    <div id="dashboard-div">
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: 15,
        }}
        className="filter-list"
      >
        <div style={{}}>
          <div
            style={{
              fontWeight: "bold",
              fontSize: 14,
              marginLeft: 20,
            }}
          >
            Parks
          </div>
          <PlaceList
            title="place-list dashboard-dropdown"
            custom_classes="place-list dashboard-dropdown"
            icon_classes="dashboard-place-dropdown-icon"
            value={queryPlace}
            options={parkList}
            onChange={(e, data) => {
              setQueryPlace(data.value);
            }}
          />
        </div>

        <div style={{ display: "flex" }}>
          <div
            style={{
              fontSize: 14,
              marginLeft: 20,
            }}
          >
            <div
              style={{
                fontWeight: "bold",
                fontSize: 14,
                marginLeft: 10,
              }}
            >
              Months
            </div>
            <MonthList
              title="Select Month"
              custom_classes="month-list dashboard-dropdown"
              value={queryMonth}
              onChange={(e, data) => {
                var _sdate = "01 " + data.value + " " + queryYear;

                _sdate = momentTz(_sdate);

                setQueryMonth(data.value);
                setQueryDate(_sdate.format("MMM-YYYY"));
              }}
            />
          </div>
          <div>
            <div
              style={{
                fontWeight: "bold",
                fontSize: 14,
              }}
            >
              Year
            </div>

            <YearList
              title="Select Year"
              custom_classes="year-list dashboard-dropdown"
              value={queryYear}
              onChange={(e, data) => {
                var _sdate = "01-" + queryMonth + "-" + data.value;

                _sdate = momentTz(_sdate);

                setQueryYear(data.value);
                setQueryDate(_sdate.format("MMM-YYYY"));
              }}
            />
          </div>
        </div>
      </div>

      {loader ? (
        <div style={{ position: "absolute", left: "50%" }}>
          <Loader active inline="centered" />
        </div>
      ) : (
        <div>
        {/* ===== Dashboard Section 1 ===== */}
        <div className="dashboard-row">
          {/* Total Incident */}
          <div className="dashboard-card">
            <h3>Total Incident</h3>
            <p className="subtext">Staff / Guest / Others</p>
            <div className="chart-area">
              {
                totalTypeofIncidentCount["Caught in between object"] !== 0 ||
                totalTypeofIncidentCount["Ergonomic"] !== 0 ||
                totalTypeofIncidentCount["Health condition"] !== 0 ||
                totalTypeofIncidentCount["Hurt by animal/insect in our care"] !== 0 || 
                totalTypeofIncidentCount["Hurt by animal/insect NOT in our care"] !== 0 || 
                totalTypeofIncidentCount["Slip and fall"] !== 0 || 
                totalTypeofIncidentCount["Trip and fall"] !== 0 || 
                totalTypeofIncidentCount["Others"] !== 0 ? (
                  <Pie data={pieTotalIncidentdata} options={options} plugins={[ChartDataLabels]} />
                ) : (
                  <h3 style={{ textAlign: "center" }}>
                    No data available{" "}
                  </h3>
                )
              }
            </div>
            <div className="legend-area">
              {Object.keys(totalTypeofIncidentCount).map((key, i) => (
                <div className="legend-item" key={i}>
                  <span className="dot" style={{ backgroundColor: [
                    "#ECBB00","#E72D35","#ff8c00","#2D8CE3","#089B46","#8F8F8F","#ce6c6cff"
                  ][i] }}></span>
                  {key} - <b>{totalTypeofIncidentCount[key]}</b>
                </div>
              ))}
            </div>
          </div>

          {/* Guest CPCBC */}
          <div className="dashboard-card">
            <h3>C, PC, BC</h3>
            <p className="subtext">Guest</p>
            <div className="chart-area">
              {
                guestCPCBCCount["C"] !== 0 ||
                guestCPCBCCount["PC"] !== 0 ||
                guestCPCBCCount["BC"] !== 0 ? (
                  <Pie data={pieGuestCPCBCdata} options={options} plugins={[ChartDataLabels]} />
                ) : (
                  <h3 style={{ textAlign: "center" }}>
                    No data available{" "}
                  </h3>
                )
              }
            </div>
            <div className="legend-area">
              {Object.keys(guestCPCBCCount).map((key, i) => (
                <div className="legend-item" key={i}>
                  <span className="dot" style={{ backgroundColor: ["#ECBB00","#E72D35","#ff8c00"][i] }}></span>
                  {key} - <b>{guestCPCBCCount[key]}</b>
                </div>
              ))}
            </div>
          </div>

          {/* Staff CPCBC */}
          <div className="dashboard-card">
            <h3>C, PC, BC</h3>
            <p className="subtext">Staff</p>
            <div className="chart-area">
              {
                staffCPCBCCount["C"] !== 0 || 
                staffCPCBCCount["PC"] !== 0 || 
                staffCPCBCCount["BC"] !== 0 ? (
                  <Pie data={pieStaffCPCBCdata} options={options} plugins={[ChartDataLabels]} />
                ) : (
                  <h3 style={{ textAlign: "center" }}>
                    No data available{" "}
                  </h3>
                )
              }
            </div>
            <div className="legend-area">
              {Object.keys(staffCPCBCCount).map((key, i) => (
                <div className="legend-item" key={i}>
                  <span className="dot" style={{ backgroundColor: ["#ECBB00","#E72D35","#ff8c00"][i] }}></span>
                  {key} - <b>{staffCPCBCCount[key]}</b>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* ===== Dashboard Section 2 ===== */}
        <div className="dashboard-row four">
          {/* Guest Incident Type */}
          <div className="dashboard-card">
            <h3>Type of Incident</h3>
            <p className="subtext">Guest</p>
            <div className="chart-area">
              {
                guestTypeofIncidentCount["Caught in between object"] !== 0 ||
                guestTypeofIncidentCount["Ergonomic"] !== 0 ||
                guestTypeofIncidentCount["Health condition"] !== 0 ||
                guestTypeofIncidentCount["Hurt by animal/insect in our care"] !== 0 || 
                guestTypeofIncidentCount["Hurt by animal/insect NOT in our care"] !== 0 || 
                guestTypeofIncidentCount["Slip and fall"] !== 0 || 
                guestTypeofIncidentCount["Trip and fall"] !== 0 || 
                guestTypeofIncidentCount["Others"] !== 0 ? (
                  <Pie data={pieGuestIncidentdata} options={options} plugins={[ChartDataLabels]} />
                ) : (
                  <h3 style={{ textAlign: "center" }}>
                    No data available{" "}
                  </h3>
                )
              }
            </div>
            <div className="legend-area">
              {Object.keys(guestTypeofIncidentCount).map((key, i) => (
                <div className="legend-item" key={i}>
                  <span className="dot" style={{ backgroundColor: [
                    "#ECBB00","#E72D35","#ff8c00","#2D8CE3","#089B46","#8F8F8F","#775656ff", "#ce6c6cff"
                  ][i] }}></span>
                  {key} - <b>{guestTypeofIncidentCount[key]}</b>
                </div>
              ))}
            </div>
          </div>

          {/* Staff Incident Type */}
          <div className="dashboard-card">
            <h3>Type of Incident</h3>
            <p className="subtext">Staff</p>
            <div className="chart-area">
              {
                staffTypeofIncidentCount["Caught in between object"] !== 0 ||
                staffTypeofIncidentCount["Ergonomic"] !== 0 ||
                staffTypeofIncidentCount["Health condition"] !== 0 ||
                staffTypeofIncidentCount["Hurt by animal/insect in our care"] !== 0 || 
                staffTypeofIncidentCount["Hurt by animal/insect NOT in our care"] !== 0 || 
                staffTypeofIncidentCount["Slip and fall"] !== 0 || 
                staffTypeofIncidentCount["Trip and fall"] !== 0 || 
                staffTypeofIncidentCount["Others"] !== 0 ? (
                  <Pie data={pieStaffIncidentdata} options={options} plugins={[ChartDataLabels]} />
                ) : (
                  <h3 style={{ textAlign: "center" }}>
                    No data available{" "}
                  </h3>
                )
              }
            </div>
            <div className="legend-area">
              {Object.keys(staffTypeofIncidentCount).map((key, i) => (
                <div className="legend-item" key={i}>
                  <span className="dot" style={{ backgroundColor: [
                    "#ECBB00","#E72D35","#ff8c00","#2D8CE3","#089B46","#8F8F8F", "#775656ff", "#ce6c6cff"
                  ][i] }}></span>
                  {key} - <b>{staffTypeofIncidentCount[key]}</b>
                </div>
              ))}
            </div>
          </div>

          {/* Guest Injury Type */}
          <div className="dashboard-card">
            <h3>Type of Injury</h3>
            <p className="subtext">Guest</p>
            <div className="chart-area">
              {
                guestWhatIsTheInjuryCount["Cut & laceration"] !== 0 ||
                guestWhatIsTheInjuryCount["Bite / Sting / Scratch"] !== 0 ||
                guestWhatIsTheInjuryCount["Sprain & strains"] !== 0 || 
                guestWhatIsTheInjuryCount["Allergy / rash"] !== 0 || 
                guestWhatIsTheInjuryCount["Bruise & contusion"] !== 0 || 
                guestWhatIsTheInjuryCount["Burn"] !== 0 || 
                guestWhatIsTheInjuryCount["Others"] !== 0 ? (
                  <Pie data={pieGuestTypeofInjurydata} options={options} plugins={[ChartDataLabels]} />
                ) : (
                  <h3 style={{ textAlign: "center" }}>
                    No data available{" "}
                  </h3>
                )
              }
            </div>
            <div className="legend-area">
              {Object.keys(guestWhatIsTheInjuryCount).map((key, i) => (
                <div className="legend-item" key={i}>
                  <span className="dot" style={{ backgroundColor: [
                    "#ECBB00","#E72D35","#ff8c00","#2D8CE3","#089B46","#8F8F8F", "#cf33b5ff"
                  ][i] }}></span>
                  {key} - <b>{guestWhatIsTheInjuryCount[key]}</b>
                </div>
              ))}
            </div>
          </div>

          {/* Staff Injury Type */}
          <div className="dashboard-card">
            <h3>Type of Injury</h3>
            <p className="subtext">Staff</p>
            <div className="chart-area">
              {
                staffWhatIsTheInjuryCount["Cut & laceration"] !== 0 ||
                staffWhatIsTheInjuryCount["Bite / Sting / Scratch"] !== 0 ||
                staffWhatIsTheInjuryCount["Sprain & strains"] !== 0 || 
                staffWhatIsTheInjuryCount["Allergy / rash"] !== 0 || 
                staffWhatIsTheInjuryCount["Bruise & contusion"] !== 0 || 
                staffWhatIsTheInjuryCount["Burn"] !== 0 || 
                staffWhatIsTheInjuryCount["Others"] !== 0 ? (
                  <Pie data={pieStaffTypeofInjurydata} options={options} plugins={[ChartDataLabels]} />
                ) : (
                  <h3 style={{ textAlign: "center" }}>
                    No data available{" "}
                  </h3>
                )
              }
            </div>
            <div className="legend-area">
              {Object.keys(staffWhatIsTheInjuryCount).map((key, i) => (
                <div className="legend-item" key={i}>
                  <span className="dot" style={{ backgroundColor: [
                    "#ECBB00","#E72D35","#ff8c00","#2D8CE3","#089B46","#8F8F8F", , "#cf33b5ff"
                  ][i] }}></span>
                  {key} - <b>{staffWhatIsTheInjuryCount[key]}</b>
                </div>
              ))}
            </div>
          </div>
        </div>
        </div>
      )}
    </div>
  );
}
const mapStateToProps = (state) => ({
  AuthDetail: state.loggedInUserDetail.userDetail,
});
export default connect(mapStateToProps, null)(IncidentList);
